// Header behavior: toggle scrolled class and mobile nav
(function(){
  const header = document.querySelector('[data-header]');
  const navToggle = document.querySelector('[data-nav-toggle]');
  const navList = document.getElementById('primary-nav');
  
  // Fonction pour détecter si on est sur une page produit
  function isProductPage() {
    return document.querySelector('.product-main') !== null;
  }
  
  // Fonction pour détecter si on est sur une page standard (mentions-légales, etc.)
  function isPageTemplate() {
    // Vérifier plusieurs façons de détecter une page template
    return document.body.classList.contains('template-page') ||
           document.body.classList.contains('page') ||
           window.location.pathname.includes('/pages/') ||
           (document.querySelector('.legal-page') !== null) ||
           (document.querySelector('section[class*="legal"]') !== null);
  }
  
  // Fonction pour détecter si on est sur une page collection
  function isCollectionPage() {
    return document.body.classList.contains('template-collection') ||
           window.location.pathname.includes('/collections/');
  }

  function onScroll(){
    if(!header) return;
    // Sur les pages produits, pages ou collections, garder la barre en mode "scrolled" en permanence
    if (isProductPage() || isPageTemplate() || isCollectionPage()) {
      header.classList.add('is-scrolled');
      return;
    }
    const scrolled = window.scrollY > 40;
    header.classList.toggle('is-scrolled', scrolled);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Force header visible on product pages, page templates and collection pages
  // Utiliser une fonction pour vérifier à nouveau au cas où le DOM n'est pas encore prêt
  function forceScrolledState() {
    if (isProductPage() || isPageTemplate() || isCollectionPage()) {
      header && header.classList.add('is-scrolled');
    }
  }
  
  // Essayer immédiatement
  forceScrolledState();
  
  // Essayer après un court délai au cas où le DOM n'est pas encore prêt
  setTimeout(forceScrolledState, 100);
  setTimeout(forceScrolledState, 500);

  if(navToggle && navList){
    navToggle.addEventListener('click', function(){
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      navList.setAttribute('aria-expanded', String(!expanded));
    });
  }

  // Show subtle arrow indicator on small screens for ingredients carousel when first load
  const ingScroller = document.querySelector('.ingredients__list');
  if(ingScroller){
    // Center on first item, ensure index 0 active on load
    ingScroller.scrollTo({ left: 0 });
  }
})();

// Market selector functionality
(function() {
  const marketToggle = document.querySelector('[data-market-toggle]');
  const marketDropdown = document.querySelector('[data-market-dropdown]');
  
  if (!marketToggle || !marketDropdown) return;
  
  // Toggle dropdown
  marketToggle.addEventListener('click', function(e) {
    e.stopPropagation();
    const isOpen = marketDropdown.classList.contains('is-open');
    marketDropdown.classList.toggle('is-open', !isOpen);
    marketDropdown.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    
    // Rotate arrow
    const arrow = this.querySelector('svg');
    if (arrow) {
      arrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
    }
  });
  
  // Close dropdown when clicking outside (but allow form submission)
  document.addEventListener('click', function(e) {
    // Ne pas fermer si on clique sur un bouton de formulaire
    if (e.target.closest('button[type="submit"]')) {
      return;
    }
    if (!marketToggle.contains(e.target) && !marketDropdown.contains(e.target)) {
      marketDropdown.classList.remove('is-open');
      marketDropdown.setAttribute('aria-hidden', 'true');
      const arrow = marketToggle.querySelector('svg');
      if (arrow) {
        arrow.style.transform = 'rotate(0deg)';
      }
    }
  });
  
  // Empêcher la propagation du clic sur les boutons de formulaire
  const marketForms = marketDropdown.querySelectorAll('form');
  marketForms.forEach(form => {
    const submitButton = form.querySelector('button[type="submit"]');
    
    if (submitButton) {
      submitButton.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  });
  
  // Close dropdown on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && marketDropdown.classList.contains('is-open')) {
      marketDropdown.classList.remove('is-open');
      marketDropdown.setAttribute('aria-hidden', 'true');
      const arrow = marketToggle.querySelector('svg');
      if (arrow) {
        arrow.style.transform = 'rotate(0deg)';
      }
    }
  });
  
  // Fonction pour obtenir l'emoji drapeau à partir du code ISO du pays
  function getCountryFlag(countryIso) {
    if (!countryIso || countryIso.length !== 2) return '';
    
    // Convertir le code ISO en emoji drapeau
    // Les codes ISO sont en majuscules (ex: FR, DE, US)
    // Les emojis drapeaux utilisent les Regional Indicator Symbols
    const codePoints = countryIso
      .toUpperCase()
      .split('')
      .map(char => 127397 + char.charCodeAt(0));
    
    return String.fromCodePoint(...codePoints);
  }
  
  // Afficher les drapeaux et les noms de pays dans leur langue native
  function updateCountryFlagsAndNames() {
    // Mettre à jour les drapeaux
    const flagElements = document.querySelectorAll('.market-selector__flag[data-country-iso]');
    flagElements.forEach(function(element) {
      const countryIso = element.getAttribute('data-country-iso');
      if (countryIso) {
        const flag = getCountryFlag(countryIso);
        if (flag) {
          element.textContent = flag;
          element.style.display = 'inline-block';
          element.style.visibility = 'visible';
        } else {
          // Si le drapeau ne peut pas être généré, afficher le code pays
          element.textContent = countryIso;
          element.style.display = 'inline-block';
        }
      }
    });
    
    // Mettre à jour les noms de pays dans leur langue native (dans la liste déroulante)
    const countryNameElements = document.querySelectorAll('.market-selector__country-name[data-country-name]');
    
    if (!countryNameElements.length) return;
    
    // Vérifier si Intl.DisplayNames est supporté
    if (typeof Intl === 'undefined' || !Intl.DisplayNames) {
      return; // Fallback sur les noms par défaut si non supporté
    }
    
    countryNameElements.forEach(function(element) {
      // Récupérer le code ISO du pays depuis l'élément parent
      const countryIso = element.closest('[data-country-iso]')?.getAttribute('data-country-iso');
      
      if (!countryIso) return;
      
      try {
        // Obtenir la langue du pays (ex: 'FR' pour France, 'DE' pour Allemagne)
        const countryLangMap = {
          'FR': 'fr', 'BE': 'fr', 'CH': 'de', 'DE': 'de', 'AT': 'de',
          'ES': 'es', 'IT': 'it', 'PT': 'pt', 'NL': 'nl', 'GB': 'en',
          'US': 'en', 'CA': 'en', 'AU': 'en', 'NZ': 'en', 'IE': 'en',
          'PL': 'pl', 'CZ': 'cs', 'SE': 'sv', 'NO': 'no', 'DK': 'da',
          'FI': 'fi', 'GR': 'el', 'RU': 'ru', 'JP': 'ja', 'CN': 'zh',
          'KR': 'ko', 'BR': 'pt', 'MX': 'es', 'AR': 'es', 'CL': 'es'
        };
        
        // Essayer de trouver la langue du pays, sinon utiliser la langue de la page
        const countryLang = countryLangMap[countryIso] || document.documentElement.lang?.split('-')[0] || 'en';
        
        // Créer un formatter pour les noms de pays
        const formatter = new Intl.DisplayNames([countryLang], { type: 'region' });
        const nativeName = formatter.of(countryIso);
        
        if (nativeName) {
          element.textContent = nativeName;
        }
      } catch (e) {
        // En cas d'erreur, garder le nom par défaut
        console.warn('Could not get native country name for', countryIso);
      }
    });
  }
  
  // Mettre à jour les drapeaux et noms au chargement et quand le dropdown s'ouvre
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCountryFlagsAndNames);
  } else {
    updateCountryFlagsAndNames();
  }
  
  // Mettre à jour aussi quand le dropdown s'ouvre (au cas où le DOM change)
  marketToggle.addEventListener('click', function() {
    setTimeout(updateCountryFlagsAndNames, 100);
  });
})();

// Featured product home section interactions
(function() {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    const amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const amountNoDecimals = parts[0];
    const amountWithComma = amount + ',' + parts[1];
    return format
      .replace('{{amount}}', amount + '.' + parts[1])
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals)
      .replace('{{amount_with_space_separator}}', amount + '.' + parts[1])
      .replace('{{amount_with_apostrophe_separator}}', amount + '.' + parts[1]);
  }

  function initHomeProductFeature(section) {
    if (!section || section.dataset.hpInit === 'true') return;
    section.dataset.hpInit = 'true';

    const configEl = section.querySelector('[data-home-product-config]');
    let config = {};
    if (configEl) {
      try {
        config = JSON.parse(configEl.textContent || '{}');
      } catch (e) {
        config = {};
      }
    }
    const moneyFormat = config.moneyFormat || '{{amount}}';
    const addToCartLabel = config.addToCartLabel || 'Ajouter au panier';
    const soldOutLabel = config.soldOutLabel || 'Indisponible';

    const mainMedia = section.querySelector('[data-main-media]');
    let mainImage = section.querySelector('[data-main-image]');
    const thumbsContainer = section.querySelector('[data-thumbs]');
    const prevButton = section.querySelector('[data-thumb-prev]');
    const nextButton = section.querySelector('[data-thumb-next]');
    const variantSelect = section.querySelector('[data-variant-select]');
    const variantsJson = section.querySelector('[data-variants-json]');
    const priceEl = section.querySelector('[data-price-amount]');
    const compareEl = section.querySelector('[data-compare-amount]');
    const addToCart = section.querySelector('[data-add-to-cart]');
    const qtyInput = section.querySelector('[data-qty-input]');

    function ensureMainImage() {
      if (mainImage || !mainMedia) return;
      const img = document.createElement('img');
      img.className = 'home-product-feature__main-image';
      img.setAttribute('data-main-image', '');
      img.loading = 'lazy';
      mainMedia.innerHTML = '';
      mainMedia.appendChild(img);
      mainImage = img;
    }

    function getThumbs() {
      return Array.from(section.querySelectorAll('[data-thumb]'));
    }

    function getCurrentIndex() {
      const active = section.querySelector('[data-thumb].is-active');
      if (active && active.dataset.thumbIndex) {
        return Number(active.dataset.thumbIndex) || 0;
      }
      const thumbs = getThumbs();
      return thumbs.findIndex((item) => item.classList.contains('is-active'));
    }

    function setActiveThumb(index) {
      const thumbs = getThumbs();
      if (!thumbs.length) return;
      ensureMainImage();
      if (!mainImage) return;
      const safeIndex = (index + thumbs.length) % thumbs.length;
      let thumb = thumbs.find((item) => Number(item.dataset.thumbIndex) === safeIndex);
      if (!thumb) thumb = thumbs[safeIndex];
      const nextSrc = thumb.getAttribute('data-src');
      const nextAlt = thumb.getAttribute('data-alt') || '';
      if (nextSrc) {
        mainImage.src = nextSrc;
        mainImage.alt = nextAlt;
      }
      thumbs.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
      if (thumbsContainer) {
        const left = thumb.offsetLeft - thumbsContainer.clientWidth / 2 + thumb.clientWidth / 2;
        thumbsContainer.scrollTo({ left, behavior: 'smooth' });
      }
    }

    if (thumbsContainer) {
      if (getThumbs().length && getCurrentIndex() === -1) {
        setActiveThumb(0);
      }
      thumbsContainer.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-thumb]');
        if (!thumb) return;
        const indexAttr = Number(thumb.dataset.thumbIndex);
        if (!Number.isNaN(indexAttr)) {
          setActiveThumb(indexAttr);
          return;
        }
        const thumbs = getThumbs();
        const index = thumbs.indexOf(thumb);
        if (index !== -1) {
          setActiveThumb(index);
        }
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        const currentIndex = getCurrentIndex();
        const safeIndex = currentIndex === -1 ? 0 : currentIndex;
        setActiveThumb(safeIndex - 1);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        const currentIndex = getCurrentIndex();
        const safeIndex = currentIndex === -1 ? 0 : currentIndex;
        setActiveThumb(safeIndex + 1);
      });
    }

    section.addEventListener('click', (event) => {
      const button = event.target.closest('[data-qty-change]');
      if (!button || !qtyInput) return;
      event.preventDefault();
      const delta = Number(button.getAttribute('data-qty-change')) || 0;
      const current = Number(qtyInput.value) || 1;
      const next = Math.max(1, current + delta);
      qtyInput.value = next;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (variantSelect && variantsJson) {
      let variants = [];
      try {
        variants = JSON.parse(variantsJson.textContent || '[]');
      } catch (e) {
        variants = [];
      }
      const updateVariant = (id) => {
        const variant = variants.find((item) => item.id === Number(id));
        if (!variant) return;
        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price, moneyFormat);
        }
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (addToCart) {
          addToCart.disabled = !variant.available;
          addToCart.textContent = variant.available ? addToCartLabel : soldOutLabel;
        }
      };
      updateVariant(variantSelect.value);
      variantSelect.addEventListener('change', (event) => {
        updateVariant(event.target.value);
      });
    }
  }

  function initAllHomeProductFeatures() {
    document
      .querySelectorAll('.home-product-feature')
      .forEach((section) => initHomeProductFeature(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHomeProductFeatures);
  } else {
    initAllHomeProductFeatures();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target?.querySelector?.('.home-product-feature') ||
      (event.target?.classList?.contains('home-product-feature') ? event.target : null);
    if (section) {
      initHomeProductFeature(section);
    }
  });
})();
